import { inject, Injectable } from '@angular/core';

import { DialogComponent } from '@plugins/client/dialog/dialog.component';
import { DialogService } from '@plugins/client/dialog/dialog.service';
import { CommonDialogConfig } from '@plugins/client/dialog/types';

import { ToastComponent } from './toast.component';
import { COMMON_TOAST_CONFIG } from './tokens';
import { ToastData } from './types';

@Injectable({ providedIn: 'root' })
export class ToastService {
  #dialogService = inject(DialogService);
  #commonConfig = inject(COMMON_TOAST_CONFIG, { optional: true }) ?? {};

  #toastTimeout?: ReturnType<typeof setTimeout>;
  #toast: DialogComponent | null = null;

  show(data: ToastData, config: CommonDialogConfig = {}) {
    this.clear();
    const { dialog } = this.#dialogService.open<ToastComponent, ToastData>(
      ToastComponent,
      data,
      { modal: false, ...this.#commonConfig, ...config },
    );
    this.#toast = dialog;

    if (data.closeTimeout) {
      this.#toastTimeout = setTimeout(() => {
        this.clear();
      }, data.closeTimeout);
    }
  }

  clear() {
    this.#toastTimeout && clearTimeout(this.#toastTimeout as unknown as number);
    this.#toast?.close();
    this.#toast = null;
  }
}
